module.exports = __webpack_public_path__ + "img/3dotsanddash.3bd0aa56.svg";